import { render, staticRenderFns } from "./TiempoDescarga.vue?vue&type=template&id=009bd793&scoped=true&"
import script from "./TiempoDescarga.vue?vue&type=script&lang=ts&"
export * from "./TiempoDescarga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bd793",
  null
  
)

export default component.exports